import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  activateUser(id: string): Observable<any> {
    return this.http.put(`${environment.apiUrl}users/${id}/activate`, null);
  }
}
